export default "__VITE_ASSET__Ca0tE5L3__"